import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref, watch } from 'vue'; import { useAuthStore } from '@/store/auth'; 
import defaultImage from '@/assets/images/defaultImage.png';



export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
    src: {}
  },
  setup(__props: any) {

const props = __props;


const authStore = useAuthStore();
const imageUrl = ref(defaultImage);

const checkIfImageExists = (src: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      resolve(true);
    };
    img.onerror = function () {
      reject(false);
    };
    img.src = src;
  });
};

const setImageUrl = () => {
  if (!props.src) return;

  if (props.src.indexOf('assets/') !== -1) {
    // Assign directly in case of assets
    imageUrl.value = props.src;
  } else if (props.src.startsWith('http')) {
    // If starts with http, it is web url check for existence and assign
    checkIfImageExists(props.src).then(() => {
      imageUrl.value = props.src as string;
    }).catch(() => {
      console.error("Image doesn't exist", props.src);
    });
  } else {
    const baseURL = authStore.getBaseUrl.replace('/api', '');
    const resolvedImageUrl = baseURL.concat(props.src);
    checkIfImageExists(resolvedImageUrl).then(() => {
      imageUrl.value = resolvedImageUrl;
    }).catch(() => {
      console.error("Image doesn't exist", resolvedImageUrl);
    });
  }
};

watch(() => props.src, () => {
  setImageUrl();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", { src: imageUrl.value }, null, 8, _hoisted_1))
}
}

})